import { Logger } from '../../02_utils/logger';
import { Utils } from '../../02_utils/utils';

export class ToTop {
  private toTopElement: HTMLElement = document.querySelector('#js-to-top');
  private threshold: number;

  constructor(private $log: Logger, private $utils: Utils, threshold: number = 10) {
    this.threshold = threshold;
    if (this.toTopElement) {
      this.toTop(this.toTopElement, this.threshold);
    }
  }

  /**
   * Handles the to top logic. Subscribes to the current scrollposition.
   * @param toTopElement the html element
   * @param threshold the threshold when the element should be shown
   */
  private toTop(toTopElement: HTMLElement, threshold: number): void {
    this.$utils.scrollPosition.subscribe(scrollPos => this.setVisibilty(toTopElement, threshold, scrollPos));
    toTopElement.addEventListener('click', (event) => {
      event.preventDefault();
      this.$log.debug('ToTop: Element', toTopElement);
      window.scroll({
        top: 0,
        behavior: 'smooth',
      })
    });
  }

  /**
   * Sets the visibility of the to top button
   */
  private setVisibilty(toTopElement: HTMLElement, threshold: number, scrollPos: number): void {
    if (scrollPos < threshold) {
      this.$utils.addOrRemoveClases('remove', 'l-to-top--active', toTopElement);
    } else {
      this.$utils.addOrRemoveClases('add', 'l-to-top--active', toTopElement);
    }
  }

}
